import { Group } from "app/types"

type HasPendingGroupMembershipRequestProps = {
  groupJoinRequests?: {
    group: Pick<Group, 'id'>
    status: string
  }[]
  groupId?: string
}

export const hasPendingGroupMembershipRequest = ({
  groupJoinRequests,
  groupId,
}: HasPendingGroupMembershipRequestProps) => {
  if (!groupId || !groupJoinRequests?.length) {
    return false
  }

  const hasPendingRequest = groupJoinRequests.some(
    (group) => group?.group.id === groupId && group.status === 'pending')

  return hasPendingRequest
}

